import React from "react"

import { usePagination } from "../../hooks/usePagination"

import styles from "./pagination.module.scss"

const DOTS = "..."
const Pagination = ({
  onPageChange,
  totalCount,
  siblingCount = 1,
  currentPage,
  pageSize,
  withClass,
}) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  })

  const onNext = () => {
    onPageChange(currentPage + 1)
  }

  const onPrevious = () => {
    onPageChange(currentPage - 1)
  }

  let lastPage = paginationRange[paginationRange.length - 1]
  return (
    <ul className={`${withClass} ${styles["pagination-container"]}`}>
      {/* Left navigation arrow */}
      <li
        className={`${styles["pagination-arrow"]} ${
          styles["pagination-arrow-left"]
        } ${parseInt(currentPage) === 1 ? styles.disabled : ""}`}
        disabled={currentPage === 1}
        onClick={onPrevious}
      >
        <div className={`${styles.arrow} ${styles.left}`} />
      </li>
      {paginationRange.map((pageNumber) => {
        // If the pageItem is a DOT, render the DOTS unicode character
        if (pageNumber === DOTS) {
          return (
            <li key="pagination_dots" className="pagination-item dots">
              &#8230;
            </li>
          );
        }

        // Render our Page Pills
        return (
          <li
            key={`pagination_${pageNumber}`}
            className={`${styles["pagination-item"]} ${
              parseInt(pageNumber) === parseInt(currentPage)
                ? styles.selected
                : ""
            }`}
            selected={pageNumber === currentPage}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </li>
        );
      })}
      {/*  Right Navigation arrow */}
      <li
        className={`${styles["pagination-arrow"]} ${styles["pagination-arrow-right"]} 
        ${parseInt(currentPage) === lastPage ? styles.disabled : ""}`}
        disabled={currentPage === lastPage}
        onClick={onNext}
      >
        <div className={`${styles.arrow} ${styles.right}`} />
      </li>
    </ul>
  );
}

export default Pagination
